import { render, staticRenderFns } from "./FormPlaceCategory.vue?vue&type=template&id=06fb4678&"
import script from "./FormPlaceCategory.vue?vue&type=script&lang=js&"
export * from "./FormPlaceCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06fb4678')) {
      api.createRecord('06fb4678', component.options)
    } else {
      api.reload('06fb4678', component.options)
    }
    module.hot.accept("./FormPlaceCategory.vue?vue&type=template&id=06fb4678&", function () {
      api.rerender('06fb4678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/placeCategory/form/FormPlaceCategory.vue"
export default component.exports